export default "__VITE_ASSET__86539878__"